import cartservice, { CartService } from "./cart/cart.service";
import checkoutservice, { CheckoutService } from "./checkout/checkout.service";

interface IService {
    cart: CartService;
    checkout: CheckoutService;
}
const Service: IService = {
    cart: cartservice,
    checkout: checkoutservice,
};

export default Service;